import type { Translation } from "@/i18n/locales/types";

export const common: Translation["common"] = {
  appName: "Punto.Firma",
  loading: "Loading…",
  cancel: "Cancel",
  confirm: "Confirm",
  retry: "Retry",
  close: "Close",
  save: "Save",
  saving: "Saving…",
  edit: "Edit",
  delete: "Delete",
  add: "Add",
  remove: "Remove",
  back: "Back",
  continue: "Continue",
  search: "Search",
  all: "All",
  none: "None",
  yes: "Yes",
  no: "No",
  more: "More",
  details: "Details",
  seeAll: "See all",
  loadMore: "Load more",
  chooseFile: "Choose file",
  noFileChosen: "No file chosen",
  copy: "Copy",
  copied: "Copied",
  never: "Never",
  unknown: "Unknown",
  noValue: "—",
  pagination: "Pagination",
  previousPage: "Previous page",
  nextPage: "Next page",
  empty: "Nothing here yet",
  noResults: "No results with these filters.",
  clearFilters: "Clear filters",
  pendingDesign: "Not built yet",
  pendingDesignDescription:
    "The structure, route and permissions of this screen are in place. It still has to be built on the API (openapi.yaml) following the approved UX proposal.",
  roles: {
    admin: "Admin",
    user: "User",
  },
  languages: {
    es: "Español",
    en: "English",
  },
  status: {
    active: "Active",
    suspended: "Suspended",
    no_valid_version: "No valid version",
    invited: "Invited",
    pending: "Pending",
    scheduled: "Scheduled",
    retired: "Retired",
    allowed: "Allowed",
    blocked: "Blocked",
    signed: "Signed",
    denied: "Denied",
    error: "Error",
    revoked: "Revoked",
    expired: "Expired",
    enabled: "Enabled",
    disabled: "Disabled",
  },
  uses: {
    login: "login",
    navigation: "browsing",
    document: "document signing",
    bulk: "bulk signing",
  },
  usesLong: {
    login: "Log in to the site",
    navigation: "Browse the site",
    document: "Sign documents",
    bulk: "Bulk signing",
  },
  useHints: {
    login:
      "Log in to the site with the certificate (TLS login through the proxy).",
    navigation:
      "Every page opened on the site while the certificate is in use.",
    document: "Sign documents the site asks for (afirma://) or from the app.",
    bulk: "Sign many documents at once from the web (coming soon).",
  },
  effects: {
    allow: "Allow",
    deny: "Deny",
  },
  certificateTypes: {
    representative: "Representative",
    seal: "Seal",
    natural_person: "Individual",
    other: "Other",
  },
  purposes: {
    login: "Login",
    document: "Document",
    bulk: "Bulk signing",
  },
  rule: {
    sentence: "{{effect}} {{uses}} on {{domains}}",
    paths: "if the path is {{paths}}",
    methods: "with {{methods}}",
    apps: "from {{apps}}",
    or: "or",
    and: "and",
    anyDomain: "no domain",
    allDomains: "all domains",
    noUses: "no use",
  },
  periods: {
    today: "Today",
    "24h": "Last 24 hours",
    "7d": "Last 7 days",
    "30d": "Last 30 days",
    "90d": "Last 90 days",
    "365d": "Last year",
  },
  relative: {
    inDays_one: "in {{count}} day",
    inDays_other: "in {{count}} days",
    daysAgo_one: "{{count}} day ago",
    daysAgo_other: "{{count}} days ago",
    today: "today",
  },
  people_one: "{{count}} person",
  people_other: "{{count}} people",
  rules_one: "{{count}} rule",
  rules_other: "{{count}} rules",
  members_one: "{{count}} member",
  members_other: "{{count}} members",
  certificates_one: "{{count}} certificate",
  certificates_other: "{{count}} certificates",
  toast: {
    saved: "Changes saved",
    copied: "Copied to clipboard",
  },
};
